import classNames from "classnames";
import { ReactNode } from "react";

import { PIVOT_PREFIX_WIDTHS, PivotPrefixWidth } from "./styles";

/** A labelled row: the prefix text, then whatever control the caller passes.
 *
 * The caller supplies the row's own width (`w-full` for most, a fixed `w-*` for
 * a filter that has to line up with its neighbours). This sets no width itself,
 * so the two never fight over the same CSS property. `textWidth` is separate —
 * it sizes the prefix label, not the row. */
export const Prefix: React.FC<
  React.PropsWithChildren<{
    className?: string;
    prefix: ReactNode;
    textWidth?: PivotPrefixWidth;
  }>
> = ({ children, className, prefix, textWidth }) => (
  <div className={classNames("flex items-baseline gap-[1em]", className)}>
    <span
      className={classNames(
        "font-semibold",
        textWidth && PIVOT_PREFIX_WIDTHS[textWidth]
      )}
    >
      {prefix}
    </span>
    {children}
  </div>
);
